export const shadows = [
  '0px 32px 48px -8px rgba(0, 0, 0, 0.10), 0px 0px 14px -4px rgba(0, 0, 0, 0.05)', // d1
  '0px 24px 24px -16px rgba(15, 15, 15, 0.20)', // d2
  '0px 40px 32px -24px rgba(15, 15, 15, 0.12)', // d3
  '0px 64px 64px -48px rgba(15, 15, 15, 0.10)', // d4
  '0px 4px 8px -4px rgba(0, 0, 0, 0.10), 0px -1px 1px 0px rgba(0, 0, 0, 0.04) inset', // d5
];
